/* EZCURB Heat Wave hero slideshow.
   Grid-stack crossfade carousel: autoplay with a pausable timer + synced
   progress bar, arrows / dots / swipe / keyboard, pause on hover / focus /
   tab-hidden. Honors prefers-reduced-motion (no autoplay, instant fade).
   Loaded site-wide (defer); no-ops on pages without the slideshow. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.ezc-hw-slide'));
    if (slides.length === 0) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.ezc-hw-dot'));
    var fill = root.querySelector('.ezc-hw-progress-fill');
    var live = root.querySelector('.ezc-hw-live');
    var autoplay = root.getAttribute('data-autoplay') !== 'false' && slides.length > 1 && !reduce;
    var interval = Math.max(2500, parseInt(root.getAttribute('data-interval'), 10) || 6000);

    var idx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (idx < 0) idx = 0;

    var timer = null, timerStart = 0, remaining = interval, paused = false;

    function setActive(n, focusDot) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === idx;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (d, i) {
        var on = i === idx;
        d.setAttribute('aria-current', on ? 'true' : 'false');
        d.tabIndex = on ? 0 : -1;
      });
      if (focusDot && dots[idx]) dots[idx].focus();
      if (live) {
        var h = slides[idx].querySelector('.ezc-hw-head');
        live.textContent = 'Slide ' + (idx + 1) + ' of ' + slides.length + (h ? ': ' + h.textContent.trim() : '');
      }
    }

    /* ---- progress bar synced to the pausable timer ---- */
    function progressFull(ms) {
      if (!fill || reduce) return;
      fill.style.transition = 'none';
      fill.style.transform = 'scaleX(0)';
      // force reflow so the reset lands before the new transition
      void fill.offsetWidth;
      requestAnimationFrame(function () {
        fill.style.transition = 'transform ' + ms + 'ms linear';
        fill.style.transform = 'scaleX(1)';
      });
    }
    function progressFreeze(fraction) {
      if (!fill || reduce) return;
      fill.style.transition = 'none';
      fill.style.transform = 'scaleX(' + fraction.toFixed(4) + ')';
    }

    /* ---- pausable autoplay ---- */
    function schedule(ms) {
      clearTimeout(timer);
      timerStart = Date.now();
      timer = setTimeout(advance, ms);
    }
    function advance() {
      setActive(idx + 1);
      remaining = interval;
      progressFull(interval);
      schedule(interval);
    }
    function start() {
      if (!autoplay) return;
      paused = false;
      remaining = interval;
      progressFull(interval);
      schedule(interval);
    }
    function pause() {
      if (!autoplay || paused) return;
      paused = true;
      clearTimeout(timer);
      var elapsed = Date.now() - timerStart;
      remaining = Math.max(0, remaining - elapsed);
      progressFreeze(1 - remaining / interval);
    }
    function resume() {
      if (!autoplay || !paused) return;
      paused = false;
      if (fill && !reduce) {
        requestAnimationFrame(function () {
          fill.style.transition = 'transform ' + remaining + 'ms linear';
          fill.style.transform = 'scaleX(1)';
        });
      }
      schedule(remaining);
    }
    /* manual navigation resets the dwell for the new slide */
    function goTo(n, focusDot) {
      setActive(n, focusDot);
      remaining = interval;
      if (autoplay && !paused) { progressFull(interval); schedule(interval); }
      else progressFreeze(0);
    }
    function next() { goTo(idx + 1); }
    function prev() { goTo(idx - 1); }

    /* ---- wiring ---- */
    var prevBtn = root.querySelector('.ezc-hw-prev');
    var nextBtn = root.querySelector('.ezc-hw-next');
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i, false); }); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prev(); }
      else if (e.key === 'ArrowRight') { next(); }
    });

    if (slides.length > 1) {
      root.addEventListener('mouseenter', pause);
      root.addEventListener('mouseleave', resume);
      root.addEventListener('focusin', pause);
      root.addEventListener('focusout', function (e) {
        if (!root.contains(e.relatedTarget)) resume();
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) pause(); else resume();
      });

      /* swipe */
      var vp = root.querySelector('.ezc-hw-viewport') || root;
      var sx = 0, sy = 0, tracking = false;
      vp.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; tracking = true;
      }, { passive: true });
      vp.addEventListener('touchend', function (e) {
        if (!tracking) return; tracking = false;
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) { dx < 0 ? next() : prev(); }
      }, { passive: true });
    }

    setActive(idx);
    start();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ezc-hw]'), initHero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
